import { getApp, getApps, initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth, inMemoryPersistence, setPersistence } from 'firebase/auth';
import { logger } from '../utils/logger';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// ── VAPID key — get from Firebase Console → Project Settings → Cloud Messaging
// → Web configuration → Generate key pair → copy the Key pair value
export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// ✅ ENABLE OFFLINE PERSISTENCE (for offline sensor viewing)
if (typeof window !== 'undefined') {
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      logger.warn('FirebaseConfig', 'Multiple browser tabs open; persistence disabled');
    } else if (err.code === 'unimplemented') {
      logger.warn('FirebaseConfig', 'Offline persistence not supported in this browser');
    }
  });
}

// ✅ SET PERSISTENCE IMMEDIATELY (not deferred with setTimeout)
if (typeof window !== 'undefined') {
  setPersistence(auth, inMemoryPersistence).catch((err) => {
    logger.warn('FirebaseConfig', 'Auth persistence setup failed', err?.message || err);
  });
}

export { app, db, auth };
